import { reactive } from 'vue';

/**
 * System Configuration status shared by the page layout (which reads it, and runs the
 * idle sign-out) and the announcement list (shown under the page title by PageHeader,
 * or by the layout on pages without one).
 *
 *  - status: GET /system-config/status (maintenance, announcements, idle minutes)
 *  - now: ticks so announcements appear and expire on their own
 *  - headers: how many PageHeaders are on the page (they show the list)
 */
export const systemState = reactive({
  status: null,
  now: Date.now(),
  headers: 0,
  // People may set their own theme (the Theme Customizer's gear shows).
  allowUserTheme: false,
  // System Configuration > Appearance is previewing an unsaved theme: the saved one
  // isn't re-applied over it, nor is it kept as the person's own.
  previewingTheme: false,
});

export const STATUS_CACHE_KEY = 'systemStatus';
